import { ActionReducerMap, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as fromSite from '../site/store/reducers/site.reducer';
import { RouterStateUrl } from '../shared/utils';
import * as fromRouter from '@ngrx/router-store';
import { RouterReducerState } from '@ngrx/router-store';

export interface State {
	siteData: fromSite.SiteState;
	router: fromRouter.RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<State> = {
	siteData: fromSite.reducer,
	router: fromRouter.routerReducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];

export const getSiteState = createFeatureSelector<State, fromSite.SiteState>('siteData');

export const selectRouter = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const getSite = createSelector(getSiteState, fromSite.getSite);

export const getSiteNames = createSelector(getSiteState, fromSite.getSiteNames);

export const getTeams = createSelector(getSiteState, fromSite.getTeams);

export const getVendors = createSelector(getSiteState, fromSite.getVendors);

export const getFolders = createSelector(getSiteState, fromSite.getFolders);

export const getHearingProtectionTypes = createSelector(getSiteState, fromSite.getHearingProtectionForSites);

export const getIsolationNotVerifiedTypes = createSelector(getSiteState, fromSite.GetIsolationNotVerifiedReasonsForSite);

export const getOrificeSizes = createSelector(getSiteState, fromSite.getOrificeSizes);

export const getPlumeLengths = createSelector(getSiteState, fromSite.getPlumeLengths);

export const getLeakStatuses = createSelector(getSiteState, fromSite.getLeakStatuses);

export const getLeakTypes = createSelector(getSiteState, fromSite.getLeakTypes);

export const getInsulationTypes = createSelector(getSiteState, fromSite.getInsulationTypes);

export const getFittings = createSelector(getSiteState, fromSite.getFittings);

export const getFittingSizes = createSelector(getSiteState, fromSite.getFittingSizes);

export const getSteamCosts = createSelector(getSiteState, fromSite.getSteamCosts);

export const getSteamCostsLoading = createSelector(getSiteState, fromSite.getSteamCostsLoading);

export const getSteamCostsSubmitting = createSelector(getSiteState, fromSite.getSteamCostsSubmitting);

export const getLeakFormDetailsLoading = createSelector(getSiteState, fromSite.getLeakFormDetailsLoading);

export const getSiteSettingsSaving = createSelector(getSiteState, fromSite.getSiteSettingsSaving);

export const getSiteSettingsSaved = createSelector(getSiteState, fromSite.getSiteSettingsSaved);

export const getSiteError = createSelector(getSiteState, fromSite.getError);

export const getUnitPreferences = createSelector(getSiteState, fromSite.getUnitPreferences);
